import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	upNextNonfinal: {
		id: 'standups.participant.up-next-nonfinal',
		defaultMessage: 'Up next',
		description: 'Heading text for active participants in the standup',
	},
	skippedNonfinal: {
		id: 'standups.participant.skipped-nonfinal',
		defaultMessage: 'Skipped',
		description: 'Heading text for inactive (skipped) participants in the standup',
	},
	unassignedNonfinal: {
		id: 'standups.participant.unassigned-nonfinal',
		defaultMessage: 'Unassigned',
		description: 'Name for the unassigned user',
	},
	shuffleParticipantsNonfinal: {
		id: 'standups.participant.shuffle-participants-nonfinal',
		defaultMessage: 'Shuffle',
		description: 'Tooltip text for shuffling all participants in the standup',
	},
});
